// Keep the operation ID across network errors and page reloads. An uncertain
// operation is resolved before accepting a different payload for the same form.
export const createTransactionRunner = ({ rpc, getActor, storage, onSuccess = () => {}, uuid = () => crypto.randomUUID() }) => {
  const active = new Set();
  const memory = new Map();
  return async (name, scope, params) => {
    const actor = await getActor();
    const key = `inventory-operation:${actor}:${name}:${scope}`;
    if (active.has(key)) throw new Error('La operación ya está en curso');
    active.add(key);
    try {
      let pending = memory.get(key);
      if (!pending && storage) {
        const saved = storage.getItem(key);
        if (saved) pending = JSON.parse(saved);
      }
      const changed = pending && JSON.stringify(pending.params) !== JSON.stringify(params);
      if (!pending) pending = { id: uuid(), params };
      memory.set(key, pending);
      if (storage) storage.setItem(key, JSON.stringify(pending));
      const { data, error } = await rpc(name, { ...pending.params, p_request_id: pending.id });
      if (error) {
        // SQL validation/permission/constraint failures roll back the transaction.
        // Transport and timeout failures may have committed: retain the request ID.
        if (/^(P0001|42501|22\w{3}|23\w{3}|40\w{3})$/.test(error.code || '')) {
          memory.delete(key);
          storage?.removeItem(key);
        }
        throw error;
      }
      memory.delete(key);
      storage?.removeItem(key);
      onSuccess();
      if (changed) {
        return { ...data, recoveredPreviousOperation: true };
      }
      return data;
    } finally {
      active.delete(key);
    }
  };
};
